const apikey = "cafe92b0c92d48ed9652fedb349b8988";
export default apikey;